import { getRequest,postRequest} from "../../../middlewares/api/actions";
import { getCcForCube, getConfiguredPluginsURL} from "../../../constants/urls";
import { getCheckImportedFileXmlSdmxObjectsUrl } from "../../../constants/urls";

export const LOADER_FORMAT_SET = 'LOADER_FORMAT_SET';

export const LOADER_CCS_READ = 'LOADER_CC_READ';
export const LOADER_CCS_HIDE = 'LOADER_CCS_HIDE';
export const LOADER_CC_SET = 'LOADER_CC_SET';
export const LOADER_CC_VALIDATION_FILE_UPLOAD = 'LOADER_CC_VALIDATION_FILE_UPLOAD';
export const LOADER_CC_FILE_SET='LOADER_CC_FILE_SET';
export const LOADER_PLUGIN_SET = "LOADER_PLUGIN_SET";
export const LOADER_CONFIGURED_PLUGINS = 'LOADER_CONFIGURED_PLUGINS';
export const SET_LOADER_FCONFIGURED_PLUGINS = 'SET_LOADER_FCONFIGURED_PLUGINS';


export const setLoaderFormat = format => ({
  type: LOADER_FORMAT_SET,
  format
});

export const readLoaderCCs = cubeId => getRequest(
  LOADER_CCS_READ,
  getCcForCube(cubeId)
);

export const hideLoaderCCs = () => ({
  type: LOADER_CCS_HIDE
});

export const setLoaderCC = ccTriplet => ({
  type: LOADER_CC_SET,
  ccTriplet
});

export const checkLoaderCcValidationFile = (file) => {

  let fileFormData = new FormData();
  fileFormData.append('file', file);

  return ({
    ...postRequest(
      LOADER_CC_VALIDATION_FILE_UPLOAD,
      getCheckImportedFileXmlSdmxObjectsUrl(),
      fileFormData,
      t => ({
        start: t('scenes.dataManager.loader.csvForm.messages.fileUpload.start'),
      })
    )
  });
};

export const setLoaderCCFile = ccFile => ({
  type: LOADER_CC_FILE_SET,
  ccFile
});


export const setLoaderPlugin = plugin => ({
  type: LOADER_PLUGIN_SET,
  plugin
})

export const getLoaderConfiguredPlugins = nodeId => getRequest(
  LOADER_CONFIGURED_PLUGINS,
  getConfiguredPluginsURL(nodeId, "FileMapping")
);

export const setLoaderConfiguredPlugin = plugin => ({
  type: SET_LOADER_FCONFIGURED_PLUGINS,
  plugin
});